module.exports = __webpack_public_path__ + "static/img/quality-control.b6837e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quality-control.png
// module id = kLmf
// module chunks = 0